import request from '@/utils/request'
//获取文件列表
export function getFileList() {
  return request({
    url: '/file/findList',
    method: 'get',
  })
}




//文件更新日志
export function getLogList() {
  return request({
    url: '/file/log/list',
    method: 'get',
  })
}